import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useProfesional } from "../context/ProfesionalContext";
import { ButtonPopup, ButtonVolver } from "@/components/ui";

const EditarContactoLanding: FC = () => {
  const navigate = useNavigate();
  const { landingData, setLandingData } = useProfesional();
  const { profesionalId, profesionId, perfilId } = useParams();

  if (!landingData) return null;

  const updateContact = (
    field: keyof typeof landingData.contact,
    value: string,
  ) => {
    setLandingData({
      ...landingData,
      contact: {
        ...landingData.contact,
        [field]: value,
      },
    });
  };

  const handleSave = () => {
    // Aquí llamas a tu API
  };

  const card = `relative overflow-hidden rounded-lg border-r-4 border-t-2 border-cyan-300/50 bg-gradient-to-br from-white/10 via-white/5 to-transparent backdrop-blur-3xl shadow-md shadow-zinc-800 p-8`;
  return (
    <div
      className="bg-zinc-950 text-white py-16 px-4 overflow-x-hidden"
      style={{
        backgroundImage: "url('/img/body/fondoContacto.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Volver */}
      <div className="absolute top-4 left-4 z-50 pointer-events-auto mb-8">
        <ButtonVolver
          onClick={() =>
            navigate(
              `/editar-landing/${profesionalId}/${profesionId}/${perfilId}`,
            )
          }
        />
      </div>
      <div
        className="
        w-full
        rounded-lg
        border-t-2
        border-b-2
        border-cyan-300
        bg-zinc-950
        py-2
        px-8
        shadow-md
        shadow-zinc-800
        backdrop-blur-xl
        mb-10
        mt-5
      "
      >
        <div
          className="
        flex flex-col
        gap-8
        md:flex-row
        md:items-center
        md:justify-between
      "
        >
          {/* INFO */}
          <div className="space-y-3 flex-1">
            <h1 className="text-3xl font-bold tracking-tight">
              Editor de Contacto
            </h1>

            <p className="text-zinc-400 text-sm max-w-md">
              Configura la información que aparecerá en la sección de contacto
              de tu landing.
            </p>
          </div>

          {/* BOTÓN */}
          <div
            className="
        flex
        flex-col
        sm:flex-row
        sm:justify-end
        sm:items-center
        gap-3
        w-full
        md:w-auto
      "
          >
            <ButtonPopup
              onClick={handleSave}
              className="
          px-4 py-2
          rounded-lg
          bg-zinc-900
          border border-white/10
          hover:border-cyan-500
          transition
          flex items-center justify-center
          whitespace-nowrap
          overflow-hidden
          text-ellipsis
          max-w-full
        "
            >
              Guardar cambios
            </ButtonPopup>
          </div>
        </div>
      </div>

      {/* CONTENIDO */}
      <div className="flex justify-center">
        <section className={`${card} w-full max-w-3xl`}>
          <h2 className="text-xl font-semibold mb-2">
            Información de contacto
          </h2>

          <p className="text-zinc-400 text-sm mb-8">
            Estos datos aparecerán en el formulario de contacto de la landing.
          </p>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-zinc-300 mb-2">
                Título
              </label>

              <input
                value={landingData.contact.title}
                onChange={(e) => updateContact("title", e.target.value)}
                className="
                    w-full
                    rounded-xl
                    bg-zinc-900
                    border
                    border-zinc-700
                    px-4
                    py-3
                    text-white
                    focus:border-cyan-400
                    focus:outline-none
                  "
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-zinc-300 mb-2">
                Email
              </label>

              <input
                type="correo_perfil"
                value={landingData.contact.correo_perfil ?? ""}
                onChange={(e) => updateContact("correo_perfil", e.target.value)}
                className="
                    w-full
                    rounded-xl
                    bg-zinc-900
                    border
                    border-zinc-700
                    px-4
                    py-3
                    text-white
                    focus:border-cyan-400
                    focus:outline-none
                  "
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-zinc-300 mb-2">
                Teléfono
              </label>

              <input
                value={landingData.contact.phone ?? ""}
                onChange={(e) => updateContact("phone", e.target.value)}
                className="
                    w-full
                    rounded-xl
                    bg-zinc-900
                    border
                    border-zinc-700
                    px-4
                    py-3
                    text-white
                    focus:border-cyan-400
                    focus:outline-none
                  "
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default EditarContactoLanding;
